import { jsx } from "react/jsx-runtime";
import "react";
import { StickyChatBotOpenerInner } from "./StickyChatBotOpenerInner.js";
import ErrorComponent from "./components/ErrorComponent/index.js";
import { useConfig } from "./context/ConfigContext.js";
import { ChatMessageErrorBoundary } from "./index.js";
function isMobileDevice() {
    if ('undefined' == typeof window) return false;
    return window.matchMedia('(max-width: 768px)').matches;
}
const StickyChatBotOpener = (props)=>{
    const { resolvedPayload } = useConfig();
    const isMobile = resolvedPayload?.isMobile ?? isMobileDevice();
    return /*#__PURE__*/ jsx(ChatMessageErrorBoundary, {
        FallbackComponent: /*#__PURE__*/ jsx(ErrorComponent, {}),
        children: /*#__PURE__*/ jsx(StickyChatBotOpenerInner, {
            ...props,
            isMobile: isMobile
        })
    });
};
export { StickyChatBotOpener };
